import { createAction } from 'redux-actions';

export const PAGE_LOADING = 'PAGE_LOADING';
export const PAGE_LOADED = 'PAGE_LOADED';
export const SET_HIDE_FOOTER = 'SET_HIDE_FOOTER';
export const SET_HIDE_HEADER = 'SET_HIDE_HEADER';

export const pageLoading = createAction(PAGE_LOADING);
export const pageLoaded = createAction(PAGE_LOADED);
export const setHideFooter = createAction(SET_HIDE_FOOTER);
export const setHideHeader = createAction(SET_HIDE_HEADER);
